module.exports = __webpack_public_path__ + "images/emoji/pray.9730f9ed49e5b47533cf.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/pray.png
// module id = 15OS
// module chunks = 2